<div *ngrxLet="soilAnalysis$ as soilAnalysis" data-test="soil-analysis">
  <ng-container>
    <div class="item-wrapper flex--row flex--nowrap">
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'yearCap' | translate }}
          <span class="text--bold"> </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          <span class="flex__child--auto">{{ year }}</span>
        </div>
      </div>
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'phosphate' | translate }} (P-AL)
          <span class="text--bold"> </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          <span class="flex__child--auto">{{ pal }}</span>
        </div>
      </div>
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'phosphorus' | translate }} - P-CaCl2 (P-PAE)
          <span class="text--bold"> </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          <span class="flex__child--auto">{{ ppae }}</span>
        </div>
      </div>
      <div class="spacing--margin-right">
        <div class="text--label">
          {{ 'phosphate' | translate }} (Pw)
          <span class="text--bold"> </span>
        </div>
        <div class="flex--row flex--nowrap flex--align-center">
          <span class="flex__child--auto">{{ pw }}</span>
        </div>
      </div>
      <div>
        <button
          mat-icon-button
          type="button"
          (click)="showCompleteViewDialog()"
          [disabled]="!soilAnalysis?.sampledCharacteristics?.length"
          data-test="soil-analysis-toggleExpanded"
        >
          <mat-icon class="text-color--white">chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
</div>
